
define('template!webshopAttributesMergeView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="text">\n    ' +
((__t = ( _.i18n('attributeMatching.mergeText', null, 'Every supplier and manual matching of %s (%c) moves to the chosen value, then %s is deleted.').replace(/%s/g, _.escape(valueLabel)).replace('%c', counts) )) == null ? '' : __t) +
'\n</div>\n<select class="into">\n    ';
 _.each(options, function (o) { ;
__p += '\n    <option value="' +
((__t = ( o.id )) == null ? '' : __t) +
'" ';
 if (o.id === intoId) { ;
__p += 'selected';
 } ;
__p += '>' +
__e( o.label ) +
'</option>\n    ';
 }); ;
__p += '\n</select>\n<div class="hint">' +
((__t = ( _.i18n('attributeMatching.mergeHint', null, 'Counts: supplier values shown as / filtered under the value. Republish the filters of the attribute afterwards.') )) == null ? '' : __t) +
'</div>\n';

}
return __p
};});

